import { type Ref, readonly, ref } from "vue";

const isOnline = ref(true);
let initialized = false;

const syncNetworkStatus = () => {
  if (typeof navigator === "undefined") return;
  isOnline.value = navigator.onLine;
};

const initializeNetworkStatus = () => {
  if (initialized || typeof window === "undefined") return;

  initialized = true;
  syncNetworkStatus();
  window.addEventListener("online", syncNetworkStatus);
  window.addEventListener("offline", syncNetworkStatus);
};

export const useNetworkStatus = (): { isOnline: Readonly<Ref<boolean>> } => {
  initializeNetworkStatus();
  return { isOnline: readonly(isOnline) };
};
